import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithMsalAuth } from "./baseApi";
import { PermissionAccess } from "@shared/models/permission";

const controllerName = '/permission'

export const permissionsApi = createApi({
  reducerPath: 'permissionssApi',
  baseQuery: baseQueryWithMsalAuth,
  endpoints: (builder) => ({
    getPermissions: builder.query<PermissionAccess[], void>({
      query: () => `${controllerName}/`,
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useLazyGetPermissionsQuery
} = permissionsApi;